<template>
  <mHeader name="会员登录" />
  <mSmallLayout tip="《中国社区发展网》欢迎您！">
    <Form @submit="onSubmit">
      <CellGroup inset>
        <Field
          v-model="formData.account"
          placeholder="请输入登录账号"
          :rules="rules.account"
        />
        <Field
          v-model="formData.password"
          type="password"
          placeholder="请输入登录密码"
          :rules="rules.password"
        />
        <Cell>
          <Button type="primary" block native-type="submit">登录</Button>
        </Cell>
        <Cell>
          没有账号？
          <router-link to="/user/register">立即注册</router-link>
        </Cell>
      </CellGroup>
    </Form>
  </mSmallLayout>
</template>
<script>
import { reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Form, Field, Button, Cell, CellGroup } from 'vant'
import { sleep } from '@/utils/tools'
import UI from '@/utils/ui'
import 'vant/es/field/style'
import 'vant/es/button/style'
import 'vant/es/cell/style'
import 'vant/es/cell-group/style'

export default {
  components: { Form, Field, Button, Cell, CellGroup },
  setup () {
    const store = useStore()
    const router = useRouter()
    const formData = reactive({
      account: '',
      password: '',
      role: 'user'
    })
    const rules = {
      account: [{ required: true, message: '请输入登录账号' }],
      password: [{ required: true, message: '请输入登录密码' }]
    }

    const onSubmit = async () => {
      await store.dispatch('user/login', formData)
      await store.dispatch('user/getInfo')
      UI.toast.success('登录成功！')
      await sleep(200)
      router.push('/user')
    }
    return {
      formData,
      onSubmit,
      rules
    }
  }
}
</script>
